import { FC } from 'react';

import BusinessButton from '../business-button/business-button';
import { COLOR, POSITION } from '../business-button/business-button.constants';

import Image from 'next/image';
import styles from './business-hub-image-hero.module.scss';
import classNames from 'classnames';

export interface BusinessHubImageHeroProps {
    title: string;
    description: string;
    ctaText?: string;
    ctaLink?: string;
    ctaColor?: COLOR;
    maxWithDescription?: number;
    industryIcon?: string;

    background: {
        backgroundRightImage?: {
            desktop: string;
            mobile?: string;
        };
        backgroundImage?: {
            desktop: string;
            mobile?: string;
        };
        backgroundColor?: string;
        textColor?: string;
    };
}

const BusinessHubImageHero: FC<BusinessHubImageHeroProps> = (props) => {
    const { title, description, maxWithDescription, industryIcon, ctaText, ctaLink, ctaColor, background } = props;

    return (
        <div className={styles.container}>
            <div className={styles.content} style={{ color: background.textColor }}>
                {industryIcon ? (
                    <div className={styles.industryIcon}>
                        <img src={industryIcon} alt={title} style={{ objectFit: 'contain', objectPosition: 'center' }} />
                    </div>
                ) : null}
                <div className={styles.title} dangerouslySetInnerHTML={{ __html: title || '' }}></div>
                <div
                    className={styles.description}
                    style={maxWithDescription ? { maxWidth: `${maxWithDescription}px` } : {}}
                    dangerouslySetInnerHTML={{ __html: description || '' }}
                ></div>
                {ctaText && (
                    <div className={styles.button}>
                        <BusinessButton color={ctaColor} position={POSITION.LEFT} link={ctaLink} buttonText={ctaText} autoMargin={false} target="_blank" />
                    </div>
                )}
            </div>
            <div className={styles.backgroundMobile} style={{ background: background.backgroundColor }} />
            <div className={styles.background} style={{ background: background.backgroundColor }}>
                {background?.backgroundRightImage?.desktop ? (
                    <div className={styles.imageRight}>
                        <picture>
                            <source media="(max-width: 998px)" srcSet={background.backgroundRightImage.mobile || background.backgroundRightImage.desktop} />
                            <Image
                                src={background.backgroundRightImage.desktop}
                                alt="Hero Image"
                                style={{ objectFit: 'cover', objectPosition: 'center' }}
                                fill={true}
                                loader={({ src, width, quality }) => {
                                    return `${src}?width=${width}&quality=${quality ?? 75}`;
                                }}
                            />
                        </picture>
                    </div>
                ) : null}
                {background?.backgroundImage?.desktop ? (
                    <div className={classNames(styles.imageImage, styles.desktop)}>
                        <picture>
                            <source media="(max-width: 765px)" srcSet={background.backgroundImage.desktop} />
                            <Image
                                src={background.backgroundImage.desktop}
                                alt=""
                                style={{ objectFit: 'cover', objectPosition: 'center' }}
                                fill={true}
                                loader={({ src, width, quality }) => {
                                    return `${src}?width=${width}&quality=${quality ?? 75}`;
                                }}
                            />
                        </picture>
                    </div>
                ) : null}
                {background?.backgroundImage?.mobile ? (
                    <div className={classNames(styles.imageImage, styles.mobile)}>
                        <picture>
                            <source media="(max-width: 765px)" srcSet={background.backgroundImage.mobile} />
                            <Image
                                src={background.backgroundImage.mobile}
                                alt=""
                                style={{ objectFit: 'cover', objectPosition: 'center' }}
                                fill={true}
                                loader={({ src, width, quality }) => {
                                    return `${src}?width=${width}&quality=${quality ?? 75}`;
                                }}
                            />
                        </picture>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default BusinessHubImageHero;
